import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  forecasts: { count: 0, results: [] },
  forecastsParams: { limit: 10, offset: 0 },
  downloadedForecast: [],

  stockZones: { count: 0, results: [] },
  stockZonesParams: { limit: 10, offset: 0 },
  stockZonesSelection: [],

  stockLocations: { count: 0, results: [] },
  stockLocationsParams: { limit: 10, offset: 0 },
  stockLocationsSelection: [],

  stockOnHand: [],
  stockOnHandParams: { limit: 10, offset: 0 },
  downloadedStockOnhand: [],

  stockMethods: [],
  stockStatus: [],
  stockFields: [],

  standardCosts: { count: 0, results: [] },
  standardCostsParams: { limit: 10, offset: 0 },

  stockLines: { count: 0, results: [] },
  stockLinesParams: { limit: 10, offset: 0 },
  stockLineStatus: [],

  warehouseCosting: { count: 0, results: [] },
  warehouseCostingParams: { limit: 10, offset: 0 },
  downloadedWarehouseCosting: [],

  warehouseInventory: [],
  warehouseLanded: [],

  warehouseCostingRange: { count: 0, results: [] },
  warehouseCostingRangeParams: { limit: 10, offset: 0 },
  downloadedWarehouseCostingRange: [],

  warehouseCostingFields: [],
  warehouseCostingRangeFields: [],

  stockReplenishments: { count: 0, results: [] },
  stockReplenishmentSelection: [],
  stockReplenishmentsParams: { limit: 10, offset: 0 },

  picklists: { count: 0, results: [] },
  picklistSelection: [],
  picklist: null,
  picklistsParams: { limit: 10, offset: 0 },
  picklistsSelection: [],

  stockPacks: { count: 0, results: [] },
  stockPacksParams: { limit: 10, offset: 0 },
  stockPack: null,
  stockPacksSelection: [],

  sites: { count: 0, results: [] },
  sitesParams: { limit: 10, offset: 0 },
  sitesSelection: [],

  workCenters: { count: 0, results: [] },
  workCentersParams: { limit: 10, offset: 0 },
  workCentersSelection: [],
  workCenterTypes: [],
};

const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {
    getForecasts: (state, action) => {
      state.forecasts = action.payload;
    },
    resetForecasts: (state, action) => {
      state.forecasts = initialState.forecasts;
    },
    createForecast: (state, action) => {
      state.forecasts.count += action.payload.length;
      state.forecasts.results = [...state.forecasts.results, action.payload];
    },
    createMultipleForecasts: (state, action) => {
      state.forecasts.count += action.payload.length;
      state.forecasts.results = [...state.forecasts.results, ...action.payload];
    },
    updateForecast: (state, action) => {
      const index = state.forecasts.results.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.forecasts.results[index] = {
          ...state.forecasts.results[index],
          from_date: action.payload.from_date,
          to_date: action.payload.to_date,
          product: action.payload.product,
          qty: action.payload.qty,
          warehouse: action.payload.warehouse,
        };
      }
    },
    updateMultipleForecast: (state, action) => {
      const forecasts = action.payload;
      forecasts.forEach(forecast => {
        const index = state.forecasts.results.findIndex(item => item.id === forecast.id);
        if (index !== -1) {
          state.forecasts.results[index] = {
            ...state.forecasts.results[index],
            ...forecast,
          };
        }
      });
    },
    deleteForecasts: (state, action) => {
      const forecasts = action.payload;
      state.forecasts.count = state.forecasts.count - action.payload.length;
      forecasts.forEach(forecast => {
        state.forecasts.results = state.forecasts?.results?.filter(item => item.id !== forecast);
      });
    },
    setForecastsParams: (state, action) => {
      state.forecastsParams = { ...action.payload };
    },
    resetForecastsParams: state => {
      state.forecastsParams = { limit: state.forecastsParams.limit, offset: 0 };
    },
    getStockOnHand: (state, action) => {
      state.stockOnHand = action.payload;
    },
    resetStockOnHand: (state, action) => {
      state.stockOnHand = initialState.stockOnHand;
    },
    setStanadardCosts: (state, action) => {
      state.standardCosts = action.payload;
    },
    setStockLines: (state, action) => {
      state.stockLines = action.payload;
    },
    resetStockLines: (state, action) => {
      state.stockLines = initialState.stockLines;
    },
    createStockOnHand: (state, action) => {
      state.stockOnHand.count += action.payload.length;
      state.stockOnHand.results = [...state.stockOnHand.results, action.payload];
    },
    createMultipleStockOnHand: (state, action) => {
      state.stockOnHand.count += action.payload.length;
      state.stockOnHand.results = [...state.stockOnHand.results, ...action.payload];
    },
    updateStandardCostParams: (state, action) => {
      state.standardCostsParams = { ...state.standardCostsParams, ...action.payload };
    },
    updateStockOnHand: (state, action) => {
      const index = state.stockOnHand.results.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.stockOnHand.results[index] = {
          ...state.stockOnHand.results[index],
          product: action.payload.product,
          warehouse: action.payload.warehouse,
          method: action.payload.method,
          allocated: action.payload.allocated,
          average_cost: action.payload.average_cost,
          nsp: action.payload.nsp,
          rejected: action.payload.rejected,
          reserved: action.payload.reserved,
          sellable: action.payload.sellable,
          unsellable: action.payload.unsellable,
          total: action.payload.total,
          status: action.payload.status,
        };
      }
    },
    updateMultipleStockOnHand: (state, action) => {
      const stocks = action.payload;
      stocks.forEach(stock => {
        const index = state.stockOnHand.results.findIndex(item => item.id === stock.id);
        if (index !== -1) {
          state.stockOnHand.results[index] = {
            ...state.stockOnHand.results[index],
            ...stock,
          };
        }
      });
    },
    setStockOnHandParams: (state, action) => {
      state.stockOnHandParams = { ...state.stockOnHandParams, ...action.payload };
    },
    resetStockOnHandParams: state => {
      state.stockOnHandParams = { limit: state.stockOnHandParams.limit, offset: 0 };
    },
    setStockLinesParams: (state, action) => {
      state.stockLinesParams = { ...state.stockLinesParams, ...action.payload };
    },
    getStockLocations: (state, action) => {
      state.stockLocations = action.payload;
    },
    getStockLocationsSelection: (state, action) => {
      state.stockLocationsSelection = action.payload;
    },
    getStockMethods: (state, action) => {
      state.stockMethods = action.payload;
    },
    resetStockMethods: state => {
      state.stockMethods = initialState.stockMethods;
    },
    getStockStatus: (state, action) => {
      state.stockStatus = action.payload;
    },
    getStockZones: (state, action) => {
      state.stockZones = action.payload;
    },
    getStockZonesSelection: (state, action) => {
      state.stockZonesSelection = action.payload;
    },
    resetStockStatus: state => {
      state.stockStatus = initialState.stockStatus;
    },
    getStockFields: (state, action) => {
      state.stockFields = action.payload;
    },
    getWarehouseCosting: (state, action) => {
      state.warehouseCosting = action.payload;
    },
    resetWarehouseCosting: (state, action) => {
      state.warehouseCosting = initialState.warehouseCosting;
    },
    createWarehouseCosting: (state, action) => {
      state.warehouseCosting.count += action.payload.length;
      state.warehouseCosting.results = [...state.warehouseCosting.results, action.payload];
    },
    createMultipleWarehouseCosting: (state, action) => {
      state.warehouseCosting.count += action.payload.length;
      state.warehouseCosting.results = [...state.warehouseCosting.results, ...action.payload];
    },
    updateWarehouseCosting: (state, action) => {
      const index = state.warehouseCosting.results.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.warehouseCosting.results[index] = {
          ...state.warehouseCosting.results[index],
          ...action.payload,
        };
      }
    },
    updateMultipleWarehouseCosting: (state, action) => {
      const costings = action.payload;
      costings.forEach(costing => {
        const index = state.warehouseCosting.results.findIndex(item => item.id === costing.id);
        if (index !== -1) {
          state.warehouseCosting.results[index] = {
            ...state.warehouseCosting.results[index],
            ...costing,
          };
        }
      });
    },
    setWarehouseCostingParams: (state, action) => {
      state.warehouseCostingParams = { ...action.payload };
    },
    resetWarehouseCostingParams: state => {
      state.warehouseCostingParams = { limit: state.warehouseCostingParams.limit, offset: 0 };
    },
    getWarehouseInventory: (state, action) => {
      state.warehouseInventory = action.payload;
    },
    resetWarehouseInventory: state => {
      state.warehouseInventory = initialState.warehouseInventory;
    },
    getWarehouseLanded: (state, action) => {
      state.warehouseLanded = action.payload;
    },
    resetWarehouseLanded: state => {
      state.warehouseLanded = initialState.warehouseLanded;
    },
    getWarehouseCostingRange: (state, action) => {
      state.warehouseCostingRange = action.payload;
    },
    resetWarehouseCostingRange: (state, action) => {
      state.warehouseCostingRange = initialState.warehouseCostingRange;
    },
    createWarehouseCostingRange: (state, action) => {
      state.warehouseCostingRange.count += action.payload.length;
      state.warehouseCostingRange.results = [
        ...state.warehouseCostingRange.results,
        action.payload,
      ];
    },
    createMultipleWarehouseCostingRange: (state, action) => {
      state.warehouseCostingRange.count += action.payload.length;
      state.warehouseCostingRange.results = [
        ...state.warehouseCostingRange.results,
        ...action.payload,
      ];
    },
    updateWarehouseCostingRange: (state, action) => {
      const index = state.warehouseCostingRange.results.findIndex(
        item => item.id === action.payload.id,
      );
      if (index !== -1) {
        state.warehouseCostingRange.results[index] = {
          ...state.warehouseCostingRange.results[index],
          from_qty: action.payload.from_qty,
          price: action.payload.price,
          to_qty: action.payload.to_qty,
          warehouse_costing: action.payload.warehouse_costing,
        };
      }
    },
    updateMultipleWarehouseCostingRange: (state, action) => {
      const costingRanges = action.payload;
      costingRanges.forEach(costingRange => {
        const index = state.warehouseCostingRange.results.findIndex(
          item => item.id === costingRange.id,
        );
        if (index !== -1) {
          state.warehouseCostingRange.results[index] = {
            ...state.warehouseCostingRange.results[index],
            ...costingRange,
          };
        }
      });
    },
    setWarehouseCostingRangeParams: (state, action) => {
      state.warehouseCostingRangeParams = action.payload;
    },
    resetWarehouseCostingRangeParams: state => {
      state.warehouseCostingRangeParams = {
        limit: state.warehouseCostingRangeParams.limit,
        offset: 0,
      };
    },
    getWarehouseCostingFields: (state, action) => {
      state.warehouseCostingFields = action.payload;
    },
    getWarehouseCostingRangeFields: (state, action) => {
      state.warehouseCostingRangeFields = action.payload;
    },
    getDownloadedForecast: (state, action) => {
      state.downloadedForecast = action.payload;
    },
    getDownloadedStockOnHand: (state, action) => {
      state.downloadedStockOnhand = action.payload;
    },
    getDownloadedWarehouseCosting: (state, action) => {
      state.downloadedWarehouseCosting = action.payload;
    },
    getDownloadedWarehouseCostingRange: (state, action) => {
      state.downloadedWarehouseCostingRange = action.payload;
    },
    setStockLineStatus: (state, action) => {
      state.stockLineStatus = action.payload;
    },
    resetStockLinesStatus: state => {
      state.stockLineStatus = initialState.stockLineStatus;
    },
    updateWarehouseCostingRangesParams: (state, action) => {
      state.warehouseCostingRangeParams = {
        ...state.warehouseCostingRangeParams,
        ...action.payload,
      };
    },
    updateStockZoneParams: (state, action) => {
      state.stockZonesParams = { ...state.stockZonesParams, ...action.payload };
    },
    updateForecastsParams: (state, action) => {
      state.forecastsParams = { ...state.forecastsParams, ...action.payload };
    },
    updateStockLocationParams: (state, action) => {
      state.stockLocationsParams = { ...state.stockLocationsParams, ...action.payload };
    },
    updateWarehouseCostingParams: (state, action) => {
      state.warehouseCostingParams = { ...state.warehouseCostingParams, ...action.payload };
    },
    getStockReplenishments: (state, action) => {
      state.stockReplenishments = action.payload;
    },
    getStockReplenishmentSelection: (state, action) => {
      state.stockReplenishmentSelection = action.payload;
    },
    resetStockReplenishments: state => {
      state.stockReplenishments = initialState.stockReplenishments;
    },
    getPicklists: (state, action) => {
      state.picklists = action.payload;
    },
    getPicklistSelection: (state, action) => {
      state.picklistSelection = action.payload;
    },
    getPicklist: (state, action) => {
      state.picklist = action.payload;
    },
    resetPicklists: (state, action) => {
      state.picklists = initialState.picklists;
    },
    resetPicklist: (state, action) => {
      state.picklist = initialState.picklist;
    },
    setPicklistsParams: (state, action) => {
      state.picklistsParams = { ...action.payload };
    },
    updatePicklistsParams: (state, action) => {
      state.picklistsParams = { ...state.picklistsParams, ...action.payload };
    },
    resetPicklistsParams: state => {
      state.picklistsParams = { limit: state.picklistsParams.limit, offset: 0 };
    },
    getStockPacksSelection: (state, action) => {
      state.stockPacksSelection = action.payload;
    },
    getStockPacks: (state, action) => {
      state.stockPacks = action.payload;
    },
    getStockPack: (state, action) => {
      state.stockPack = action.payload;
    },
    resetStockPacks: state => {
      state.stockPacks = initialState.stockPacks;
    },
    resetStockPack: state => {
      state.stockPack = initialState.stockPack;
    },
    setStockPacksParams: (state, action) => {
      state.stockPacksParams = { ...action.payload };
    },
    updateStockPacksParams: (state, action) => {
      state.stockPacksParams = { ...state.stockPacksParams, ...action.payload };
    },
    resetStockPacksParams: state => {
      state.stockPacksParams = { limit: state.stockPacksParams.limit, offset: 0 };
    },
    getWorkCenters: (state, action) => {
      state.workCenters = action.payload;
    },
    getWorkCentersSelection: (state, action) => {
      state.workCentersSelection = action.payload;
    },
    getWorkCenterTypes: (state, action) => {
      state.workCenterTypes = action.payload;
    },
    updateWorkCentersParams: (state, action) => {
      state.workCentersParams = { ...state.workCentersParams, ...action.payload };
    },
    setStockReplenishmentsParams: (state, action) => {
      state.stockReplenishmentsParams = { ...action.payload };
    },
    updateStockReplenishmentsParams: (state, action) => {
      state.stockReplenishmentsParams = {
        ...state.stockReplenishmentsParams,
        ...action.payload,
      };
    },
    bulkUpdateStockReplenishmentStatus: (state, action) => {
      const { ids, status } = action.payload;
      state.stockReplenishments.results = state.stockReplenishments.results.map(item => {
        if (ids.includes(item.id)) {
          return { ...item, status };
        }
        return item;
      });
    },
    resetStockReplenishmentsParams: state => {
      state.stockReplenishmentsParams = { limit: state.stockReplenishmentsParams.limit, offset: 0 };
    },
    getSites: (state, action) => {
      state.sites = action.payload;
    },
    getSitesSelection: (state, action) => {
      state.sitesSelection = action.payload;
    },
    resetSites: state => {
      state.sites = initialState.sites;
    },
    setSitesParams: (state, action) => {
      state.sitesParams = { ...action.payload };
    },
    updateSitesParams: (state, action) => {
      state.sitesParams = { ...state.sitesParams, ...action.payload };
    },
    resetSitesParams: state => {
      state.sitesParams = { limit: state.sitesParams.limit, offset: 0 };
    },
  },
});

export const {
  getForecasts,
  resetForecasts,
  createForecast,
  createMultipleForecasts,
  updateForecast,
  updateMultipleForecast,
  deleteForecasts,
  setForecastsParams,
  resetForecastsParams,
  getStockOnHand,
  resetStockOnHand,
  setStockLines,
  setStanadardCosts,
  resetStockLines,
  createStockOnHand,
  createMultipleStockOnHand,
  updateStandardCostParams,
  updateStockOnHand,
  updateMultipleStockOnHand,
  setStockOnHandParams,
  resetStockOnHandParams,
  setStockLinesParams,
  getStockMethods,
  resetStockMethods,
  getStockStatus,
  getStockZones,
  getStockZonesSelection,
  resetStockStatus,
  getStockFields,
  getWarehouseCosting,
  resetWarehouseCosting,
  createWarehouseCosting,
  createMultipleWarehouseCosting,
  updateWarehouseCosting,
  updateMultipleWarehouseCosting,
  setWarehouseCostingParams,
  resetWarehouseCostingParams,
  getWarehouseInventory,
  resetWarehouseInventory,
  getWarehouseLanded,
  resetWarehouseLanded,
  getWarehouseCostingRange,
  resetWarehouseCostingRange,
  createWarehouseCostingRange,
  createMultipleWarehouseCostingRange,
  updateWarehouseCostingRange,
  updateMultipleWarehouseCostingRange,
  setWarehouseCostingRangeParams,
  resetWarehouseCostingRangeParams,
  getWarehouseCostingFields,
  getWarehouseCostingRangeFields,
  getDownloadedForecast,
  getDownloadedStockOnHand,
  getDownloadedWarehouseCosting,
  getDownloadedWarehouseCostingRange,
  setStockLineStatus,
  resetStockLineStatus,
  updateStockZoneParams,
  updateForecastsParams,
  updateWarehouseCostingRangesParams,
  updateWarehouseCostingParams,
  getStockLocations,
  getStockLocationsSelection,
  updateStockLocationParams,
  getStockReplenishments,
  getStockReplenishmentSelection,
  resetStockReplenishments,
  setStockReplenishmentsParams,
  updateStockReplenishmentsParams,
  bulkUpdateStockReplenishmentStatus,
  resetStockReplenishmentsParams,
  getPicklists,
  getPicklistSelection,
  getPicklist,
  resetPicklists,
  resetPicklist,
  setPicklistsParams,
  updatePicklistsParams,
  resetPicklistsParams,
  getStockPacksSelection,
  getStockPacks,
  getStockPack,
  resetStockPack,
  resetStockPacks,
  setStockPacksParams,
  updateStockPacksParams,
  resetStockPacksParams,
  getSites,
  getSitesSelection,
  resetSites,
  setSitesParams,
  updateSitesParams,
  resetSitesParams,
  getWorkCenters,
  getWorkCentersSelection,
  getWorkCenterTypes,
  updateWorkCentersParams,
} = warehouseSlice.actions;

export default warehouseSlice.reducer;
